module.exports = __webpack_public_path__ + "static/media/ProblemSolving.07a61bc7.mp3";